import React from 'react'

const Textbox = ({width,height,value,placeholder,border,setValue}) => {

  return (
    <div>
      <input type='text' value={value} 
        placeholder={placeholder ? placeholder : null}
        className='text_box'
        pattern="[0-9]*"
        onChange={(e) => setValue(e.target.value)}
        style={{ height: `${height}px`, width: `${width}px`,border: '1px solid rgb(226, 226, 226)',borderRadius:`${border ? border : '10px'}`,padding:'5px'}}/>
    </div>
  )
}

export default Textbox
